import { render } from "./MenuLogo.vue?vue&type=template&id=c2d30e32&scoped=true&ts=true"
import script from "./MenuLogo.vue?vue&type=script&lang=ts"
export * from "./MenuLogo.vue?vue&type=script&lang=ts"

import "./MenuLogo.vue?vue&type=style&index=0&id=c2d30e32&lang=scss"
import "./MenuLogo.vue?vue&type=style&index=1&id=c2d30e32&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d30e32"]])

export default __exports__